import { post } from '../index'
export default {
  // 列表
  closureInfo (querys) {
    return post('/closure/admin/AdminClosure/closureInfo', querys)
  },
  // 编辑
  closureUpdate (querys) {
    return post('/closure/admin/AdminClosure/closureUpdate', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/closure.js